// shared-edit-panel-routes.constants.ts

export const SHARED_EDIT_PANEL_ROUTES = {
  // Workspace routes
  WORKSPACE_ROOT_PROPERTY: 'workspace-root-property',
  WORKSPACE_NODE_PROPERTY: 'workspace-node-property',
  WORKSPACE_EDGE_PROPERTY: 'workspace-edge-property',
  WORKSPACE_ROOT_ATTACHMENTS: 'workspace-root-attachments',
  WORKSPACE_NODE_ATTACHMENTS: 'workspace-node-attachments',

  // Blueprint field routes
  BLUEPRINT_FIELD_CHECKBOX: 'blueprint-field-checkbox',
  BLUEPRINT_FIELD_DATE: 'blueprint-field-date',
  BLUEPRINT_FIELD_DATETIME: 'blueprint-field-datetime',
  BLUEPRINT_FIELD_DROPDOWN_SINGLE: 'blueprint-field-dropdown-single',
  BLUEPRINT_FIELD_DROPDOWN_MULTIPLE: 'blueprint-field-dropdown-multiple',
  BLUEPRINT_FIELD_MEMO: 'blueprint-field-memo',
  BLUEPRINT_FIELD_NUMBER: 'blueprint-field-number',
  BLUEPRINT_FIELD_RADIO_GROUP: 'blueprint-field-radio-group',
  BLUEPRINT_FIELD_TABLE: 'blueprint-field-table',
  BLUEPRINT_FIELD_USER: 'blueprint-field-user',
  BLUEPRINT_FIELD_URL: 'blueprint-field-url',
  BLUEPRINT_FIELD_FORMATTED_TEXT: 'blueprint-field-formatted-text',
  BLUEPRINT_FIELD_TEXT: 'blueprint-field-text',

  // Blueprint property routes
  BLUEPRINT_EDGE_PROPERTY: 'blueprint-edge-property',
  BLUEPRINT_ROOT_PROPERTY: 'blueprint-root-property',
  BLUEPRINT_NODE_PROPERTY: 'blueprint-node-property',
} as const;
